import { useState, useEffect } from "react";
import { Icon } from "@iconify/react";

export default function Checkbox({
  isTimeOver,
  taskname,
  priority,
  taskId,
  checkedTasks,
  setCheckedTasks,
  isSelected,
  isFirst,
  taskStarted,
  setTaskStarted,
  setCount,
  group,
  selectedTaskState,
  startedTaskId,
  setStartedTaskId,
}) {
  const isChecked = checkedTasks[taskId] || false;
  useEffect(() => {
    const storedCheckedTasks = JSON.parse(localStorage.getItem("checkedTasks"));
    if (storedCheckedTasks) {
      setCheckedTasks(storedCheckedTasks);
    }
  }, []);

  const handleCheckboxChange = () => {
    if (!isTimeOver) {
      setCheckedTasks((prev) => {
        const updatedTasks = {
          ...prev,
          [taskId]: !isChecked,
        };
        localStorage.setItem("checkedTasks", JSON.stringify(updatedTasks)); // Save to Local Storage
        return updatedTasks;
      });
    }
  };
  const iconMap = {
    1: { icon: "material-symbols:star-rounded", className: "icon-star" },
    2: {
      icon: "material-symbols:cards-star-rounded",
      className: "icon-silver",
    },
    3: { icon: "codicon:sparkle-filled", className: "icon-silver" },
    4: { icon: "fontisto:star-half", className: "icon-brown" },
  };
  return (
    <>
      <div
        style={{
          display: "inline-block",
          width: "20px",
          height: "20px",
          border: "2px solid black",
          borderRadius: "5px",
          backgroundColor: "white",
          position: "relative",
          cursor: isTimeOver ? "pointer" : "not-allowed",
        }}
        onClick={handleCheckboxChange}
      >
        <div
          style={{
            width: "10px",
            height: "10px",
            backgroundColor:
              isTimeOver && isChecked === false
                ? "red"
                : isChecked
                ? "#00ff32"
                : "transparent",
            borderRadius: "50%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            animation:
              isChecked === false && taskStarted && isTimeOver === false
                ? "blink 1s infinite"
                : "none",
          }}
        />
      </div>
      <li
        className="act"
        style={{
          color: isTimeOver && isChecked === false ? "#FE4141" : "white",
          textDecoration: isChecked || isTimeOver ? "line-through" : "none",
          textDecorationColor:
            isTimeOver && isChecked === false
              ? "#FE4141"
              : isChecked
              ? "grey"
              : "inherit",
        }}
      >
        {taskname}
      </li>
      <button
        className="icon play-button"
        onClick={(event) => {
          event.stopPropagation(); // Prevent toggling task selection
          setCount(
            group.tasks.find((task) => task.taskId === selectedTaskState)
              .timeRequired * 60
          );
          if (isSelected) {
            setTaskStarted(true);
            if (taskStarted === false) {
              setStartedTaskId(
                group.tasks.find((task) => task.taskId === selectedTaskState)
                  .taskId
              );
            }
          }
          // console.log(startedTaskId);
        }}
      >
        {startedTaskId === taskId && taskStarted ? (
          <Icon icon="line-md:uploading-loop" className="icon-started icon" />
        ) : isSelected && !taskStarted ? (
          <Icon
            icon="fluent:flash-play-20-filled"
            className="icon-silver icon"
          />
        ) : (
          iconMap[priority] && (
            <Icon
              icon={iconMap[priority].icon}
              className={iconMap[priority].className}
            />
          )
        )}
      </button>
    </>
  );
}
